import { useIfcMode } from '@editorHooks'

interface BuildingMode {
  isBuildingActive: boolean
  toggleBuilding: () => void
}

/**
 * Building ("Gebäude") mode for the IFC Import page, backed by the global editor mode
 * (`'ifc-building'`). While active, the page drawer shows the shared BuildingForm.
 */
const useIFCImportBuildingMode = (): BuildingMode => {
  const { ifcMode, setIfcMode } = useIfcMode()

  const isBuildingActive = ifcMode === 'building'

  const toggleBuilding = () => setIfcMode(isBuildingActive ? null : 'building')

  return { isBuildingActive, toggleBuilding }
}

export default useIFCImportBuildingMode
